import React, { useEffect, useState } from 'react';
import StepComponent from 'components/StepComponent/CustomSteps';
import { getStepsMainRisk } from 'constants/inventorySteps';
import { useTranslation } from 'react-i18next';

const ICTRiskSteps: React.FC = () => {
  const { t } = useTranslation();
  const stepsMainRisk = getStepsMainRisk(t);
  const [current, setCurrent] = useState(0);
  const title = stepsMainRisk[current]?.title;

  return (
    <StepComponent
      steps={stepsMainRisk}
      current={current}
      onStepChange={setCurrent}
      title={title}
    />
  );
};

export default ICTRiskSteps;
